// Convert to ts after https://github.com/Microsoft/TypeScript/pull/24959 is released and we update
// https://github.com/TypeStrong/ts-loader/issues/793
// https://github.com/Microsoft/TypeScript/issues/12976#issuecomment-393890391

//declare const ceregoTranslate: ng.IModule; // move to a common types declaration later

import * as en from '../../../../../../config/locales/js/en.json';
angular.module('cerego.translate').constant('translateEn', en);
